import EmailIcon from '@mui/icons-material/Email';
import { Avatar, IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import PageHeaderDialogs from '../../../enums/PageHeaderDialogs';
import { settingsRoutes } from '../../../routes';
import { useAppSelector } from '../../../store/hooks';

interface Props {
    isMenuItem?: boolean;
}

export function UserEmailSetupButton({ isMenuItem }: Props) {
    const { classes } = useStyles();
    const history = useHistory();
    const isEmailBroken = useAppSelector(state => state.user.userEmailBroken);

    const handleClick = () => {
        history.push(settingsRoutes.userEmail);
    };

    //if email is not broken, do not show button
    if (!isEmailBroken) {
        return null;
    }

    if (isMenuItem) {
        return (
            <MenuItem onClick={handleClick}>
                <ListItemIcon>
                    <EmailIcon />
                </ListItemIcon>
                <ListItemText primary="Email credentials has expired" />
            </MenuItem>
        );
    }

    return (
        <Tooltip title="Email credentials has expired">
            <Avatar className={classes.showWarning}>
                <IconButton
                    data-name={PageHeaderDialogs.createContact}
                    onClick={handleClick}
                    className={classes.iconButton}
                    size="large"
                >
                    <EmailIcon />
                </IconButton>
            </Avatar>
        </Tooltip>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    showWarning: {
        backgroundColor: theme.palette.warning.main,
    },
    iconButton: {
        padding: theme.spacing(1),
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));
